import { useEffect, useState } from "react";

// 多語言時間描述
const timeDescriptions = {
    zh: {
        today: "今天",
        yesterday: "昨天",
        tomorrow: "明天",
        days_ago: "{} 天前",
        days_later: "{} 天後",
        hours_ago: "{} 小時前",
        minutes_ago: "{} 分鐘前",
        just_now: "剛剛",
    },
    en: {
        today: "Today",
        yesterday: "Yesterday",
        tomorrow: "Tomorrow",
        days_ago: "{} days ago",
        days_later: "In {} days",
        hours_ago: "{} hours ago",
        minutes_ago: "{} minutes ago",
        just_now: "Just now",
    },
    ja: {
        today: "今日",
        yesterday: "昨日",
        tomorrow: "明日",
        days_ago: "{} 日前",
        days_later: "{} 日後",
        hours_ago: "{} 時間前",
        minutes_ago: "{} 分前",
        just_now: "たった今",
    },
    ko: {
        today: "오늘",
        yesterday: "어제",
        tomorrow: "내일",
        days_ago: "{} 일 전",
        days_later: "{} 일 후",
        hours_ago: "{} 시간 전",
        minutes_ago: "{} 분 전",
        just_now: "방금 전",
    },
    fr: {
        today: "Aujourd'hui",
        yesterday: "Hier",
        tomorrow: "Demain",
        days_ago: "Il y a {} jours",
        days_later: "Dans {} jours",
        hours_ago: "Il y a {} heures",
        minutes_ago: "Il y a {} minutes",
        just_now: "À l'instant",
    },
    de: {
        today: "Heute",
        yesterday: "Gestern",
        tomorrow: "Morgen",
        days_ago: "Vor {} Tagen",
        days_later: "In {} Tagen",
        hours_ago: "Vor {} Stunden",
        minutes_ago: "Vor {} Minuten",
        just_now: "Gerade eben",
    },
    es: {
        today: "Hoy",
        yesterday: "Ayer",
        tomorrow: "Mañana",
        days_ago: "Hace {} días",
        days_later: "En {} días",
        hours_ago: "Hace {} horas",
        minutes_ago: "Hace {} minutos",
        just_now: "Justo ahora",
    },
    it: {
        today: "Oggi",
        yesterday: "Ieri",
        tomorrow: "Domani",
        days_ago: "{} giorni fa",
        days_later: "In {} giorni",
        hours_ago: "{} ore fa",
        minutes_ago: "{} minuti fa",
        just_now: "Proprio adesso",
    },
    ru: {
        today: "Сегодня",
        yesterday: "Вчера",
        tomorrow: "Завтра",
        days_ago: "{} дней назад",
        days_later: "Через {} дней",
        hours_ago: "{} часов назад",
        minutes_ago: "{} минут назад",
        just_now: "Только что",
    },
};

// 時間格式轉換函數
const formatRelativeTime = (date, lang = "en") => {
    const descriptions = timeDescriptions[lang] || timeDescriptions["en"];
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInSeconds < 60) {
        return descriptions.just_now;
    } else if (diffInMinutes < 60) {
        return descriptions.minutes_ago.replace("{}", diffInMinutes);
    } else if (diffInHours < 24) {
        return descriptions.hours_ago.replace("{}", diffInHours);
    } else if (diffInDays === 1) {
        return descriptions.yesterday;
    } else if (diffInDays > 1 && diffInDays < 7) {
        return descriptions.days_ago.replace("{}", diffInDays);
    } else if (diffInDays === -1) {
        return descriptions.tomorrow;
    } else if (diffInDays < 0) {
        return descriptions.days_later.replace("{}", Math.abs(diffInDays));
    } else {
        return descriptions.days_ago.replace("{}", diffInDays);
    }
};

// React Hook，傳入時間和語言
export const useRelativeTime = (date, lang = "en") => {
    const [relativeTime, setRelativeTime] = useState("");

    useEffect(() => {
        setRelativeTime(formatRelativeTime(new Date(date), lang));

        const interval = setInterval(() => {
            setRelativeTime(formatRelativeTime(new Date(date), lang));
        }, 60000); // 每 1 分鐘更新一次

        return () => clearInterval(interval);
    }, [date, lang]);

    return relativeTime;
};
